import Card from './Card'
export default Card
export type { ICard } from './Card.types'
